module.exports = __webpack_public_path__ + "static/boticon-5ebafab052a600d4a1f3e65c5abe9eaf.png";